import React, { useCallback, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ProductPageBody from '../components/ProductPageBody';
import MainLayOut from '../layout/MainLayOut';
import MobileMainLayout from '../layout/MobileMainLayout';
import axios from 'axios';
import { useGlobal } from '../global/GlobalContext';
import NotFound from './NotFound';

const ProductCardSkeleton = () => (
  <div className="rounded-2xl border border-gray-100 bg-white overflow-hidden shadow-sm">
    <div className="aspect-[4/5] bg-gray-200" />
    <div className="p-2.5 md:p-4 space-y-2">
      <div className="h-2.5 w-1/3 bg-gray-200 rounded" />
      <div className="h-3.5 w-4/5 bg-gray-200 rounded" />
      <div className="h-4 w-1/2 bg-gray-200 rounded mt-1" />
    </div>
  </div>
);

const ProductsGridSkeleton = () => (
  <div className="bg-gray-50 max-w-8xl mx-auto px-0 md:px-6 lg:px-8 mb-12 mt-4 pb-4 animate-pulse">
    <div className="hidden md:flex items-center gap-2 mb-5">
      <div className="h-3 w-10 bg-gray-200 rounded" />
      <div className="h-3 w-3 bg-gray-200 rounded" />
      <div className="h-3 w-24 bg-gray-200 rounded" />
    </div>

    <div className="flex justify-between flex-col md:flex-row gap-6">
      {/* Sidebar skeleton */}
      <div className="hidden md:block w-1/5">
        <div className="rounded-2xl border border-gray-100 bg-white p-5 shadow-sm space-y-6">
          <div className="h-4 w-16 bg-gray-200 rounded" />
          {[...Array(3)].map((_, i) => (
            <div key={i} className="space-y-3">
              <div className="h-3 w-20 bg-gray-200 rounded" />
              <div className="h-3 w-3/4 bg-gray-200 rounded" />
              <div className="h-3 w-2/3 bg-gray-200 rounded" />
              <div className="h-3 w-1/2 bg-gray-200 rounded" />
            </div>
          ))}
        </div>
      </div>

      {/* Product grid skeleton */}
      <div className="w-full md:w-4/5">
        <div className="flex justify-between items-center mb-5">
          <div className="h-6 w-40 bg-gray-200 rounded" />
          <div className="h-9 w-28 bg-gray-200 rounded-xl" />
        </div>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-5">
          {[...Array(9)].map((_, i) => (
            <ProductCardSkeleton key={i} />
          ))}
        </div>
      </div>
    </div>
  </div>
);

function ProductPage({ showAll }) {
  const { categorySlug } = useParams();
  const [ productLength, setProductLength ] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showRetry, setShowRetry] = useState(false);
  const [catagoryProducts, setCatagoryProducts] = useState([]);
  const {token} = useGlobal();
  const navigate = useNavigate();

  // Safety net for a genuinely stuck/hung fetch — a retry option appears
  // after 10s of loading, without taking over the whole screen.
  useEffect(() => {
    if (!loading) {
      setShowRetry(false);
      return;
    }
    const timer = setTimeout(() => setShowRetry(true), 10000);
    return () => clearTimeout(timer);
  }, [loading]);

  const fetchProducts = useCallback( async () => {
    setLoading(true);
    
    if(categorySlug && categorySlug !== 'categories'){
      // console.log('categorySlug', categorySlug);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/get_slug_data/${categorySlug}`,{
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          },
      });
      
      // console.log('response', response);

      // if(response.data.status === false) {
      //   console.log('dddd');
      // }
       
      if(response.data.status){ 
        const dataProducts = response.data;
        setProductLength(dataProducts.total_products);
        setCatagoryProducts(dataProducts);
        // console.log('categorySlug', categorySlug);
        // console.log('dataProducts', response.data);
      } else {
        navigate('/404');
      }
      
    } else {
      console.log('token', token);
      console.log('api link', `${process.env.REACT_APP_API_URL}/api/v1/get_active_products`);
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/v1/get_active_products`,{
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
          },
      });
      setProductLength(response.data.products.length);
      setProducts(response.data);
      console.log('dataProductsghgh', response.data);
    } 
    setLoading(false);
    },[categorySlug, token, setCatagoryProducts, setProducts]);

  useEffect(() => {  
      fetchProducts();
      }, [fetchProducts]);

if(!products){
  return (
    <NotFound />
  )
}

const body = loading ? (
  <>
    <ProductsGridSkeleton />
    {showRetry && (
      <div className="flex flex-col items-center py-6">
        <p className="text-sm text-gray-500 mb-3">This is taking longer than usual.</p>
        <button
          onClick={() => window.location.reload()}
          className="px-6 py-2 bg-brand-600 text-white text-sm font-semibold rounded-lg shadow-md hover:bg-brand-700 transition"
        >
          Try Again
        </button>
      </div>
    )}
  </>
) : (
  (catagoryProducts || products) && (
    <ProductPageBody products={products} catagoryProducts={catagoryProducts} categorySlug={showAll ? null : categorySlug} />
  )
);

  return(
    <>
    <div className='hidden md:block'>
      <MainLayOut>
        {body}
      </MainLayOut>
    </div>
    <div className='md:hidden'>
        <MobileMainLayout link='javascript:;' ProductsCount={`${productLength} products`} title={showAll ? 'All Products' : categorySlug}>
        {body}
        </MobileMainLayout>
    </div>

    </>
  )
}

export default ProductPage;
